// extracted by mini-css-extract-plugin
export default {"space":"lsf-space","space_direction_horizontal":"lsf-space_direction_horizontal","space_direction_vertical":"lsf-space_direction_vertical","space_spread":"lsf-space_spread","space_align_start":"lsf-space_align_start","space_align_end":"lsf-space_align_end","space_stretch":"lsf-space_stretch","space_size_large":"lsf-space_size_large","space_size_small":"lsf-space_size_small","space_size_none":"lsf-space_size_none","space_collapsed":"lsf-space_collapsed"};
    if(module.hot) {
      // 1732531516171
      var cssReload = require("/home/kartik/kvr-lsf/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  